module.exports = "static/assets/208e2134a0e95cbdd211a82d2863d88d.woff2";